// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1tg_V","infoBtn":"quickbooks_infoBtn__2Re9w","formBox":"quickbooks_formBox__49fl-","formFooter":"quickbooks_formFooter__1a02u"};